<template>
    <div class="edc-modal">
        <SOSlotModal :modal-title="`Ubah paket`" :modal-id="modalId" @close="back">
            <template v-slot:modal-body>
                <div class="f-16 f-regular f-c-black">
                    <label class="m-d-16 p-t-20">
                        Dengan mengubah paket, maka paket yang lama akan hangus dan tergantikan dengan paket yang baru.
                    </label>
                </div>
            </template>
            <template v-slot:modal-footer>
                <div class="">
                    <SOButton
                        :primary="true"
                        :full="true"
                        :text="'Lanjutkan'"
                        :id="`do-update-paket`"
                        :disable="isFetching"
                        :loading="isFetching"
                        @action="nextStep"
                    />
                    <SOButton
                        :outline="true"
                        :full="true"
                        :text="'Batal'"
                        :id="'batal-update-paket'"
                        :disable="isFetching"
                        :loading="isFetching"
                        @action="back"
                    />
                </div>
            </template>
        </SOSlotModal>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";
import SOButton from "@/so-components/global/ui/SOButton";

import { moduleName } from "../../store/state";

export default {
    name: "ModalGantiPaket",
    components: {
        SOSlotModal,
        SOButton,
    },
    data() {
        return {
            backLink: "wa_autosender.detail_perangkat",
            modalId: "modal-ganti-paket",
        };
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    mounted() {
        $(`#${this.modalId}`).modal("show");
    },
    computed: {
        ...mapGetters(moduleName, {
            dataDevice: "dataDevice",
            isFetching: "isFetching",
        }),
    },
    methods: {
        async back() {
            await this.$router.push({ name: this.backLink });
        },
        closeModal() {
            $(`#${this.modalId}`).modal("hide");
        },
        nextStep() {
            this.$router.push({ name: "wa_autosender.detail_perangkat.ubah_paket_1" });
        }
    },
};
</script>
<style scoped>
.diskon-percent {
    padding: 2px 8px;
    border-radius: 25px;
    background-color: #ededed;
    width: fit-content;
}

.paket-wa {
    max-width: unset;
}
@media (min-width: 320px) {
    .paket-wa {
        max-width: 170px;
    }
}

@media (min-width: 360px) {
    .paket-wa {
        max-width: 210px;
    }
}

@media (min-width: 400px) {
    .paket-wa {
        max-width: 250px;
    }
}
</style>
